<template>
  <div class="service-page">
    <section class="masthead hero-text-img-section">
      <div class="container-fluid px-0">
        <div class="row justify-content-center mt-10 border-20">
          <div class="col-lg-12 z-100 text-center">
            <h1 class="secondary-color">Foreign Education Consultants </h1>

            <p class="main-content-1 mt-2">

              From Consulting for Global Placement, Embark on a Journey of
              Success
            </p>
          </div>
          <div class="col-lg-12 text-center abroad-hero-img">
            <img src="@/assets/imgs/study-abroad-hero-img.png" alt="Foreign Study Consultancy" data-aos="fade-up"
              data-aos-duration="500" class="img-fluid responsive_ill_img" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: "foreignStudyConsultancy",
  metaInfo: {
    title:
      "Foreign Education Consultants - Foreign Study Consultancy - Aliff",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Looking for Foreign Education Consultants? Aliff offers the best foreign education consultants. Start your Journey with our expert advice. Consult now!",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },
  beforeMount(){
    document.querySelector('meta[name="description"]').setAttribute('content',"Looking for Foreign Education Consultants? Aliff offers the best foreign education consultants. Start your Journey with our expert advice. Consult now!");
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/foreignStudyConsultancy.vue